// import React from "react";


// const AdminPanel = () => {
//     return (
//         // <div style={{ maxWidth: "500px", margin: "0 auto", padding: "20px", border: "1px solid #ccc", borderRadius: "10px" }}>
//         //     <h2>Admin Panel</h2>
//         //     <CreateUserForm />
//         //     <UpdateUserForm />
//         // </div>
//         <div className="admin-container">
//       <div className="max-w-4xl w-full shadow-lg rounded-lg p-6 space-y-6">
//         <h2 className="text-3xl font-semibold text-gray-800 text-center">Admin Dashboard</h2>


//       </div>
//     </div>
//     );
// };

// export default AdminPanel;


import React from "react";
import { Link } from "react-router-dom";

const AdminPanel = () => {
  return (
    <div className="admin-container">
      <div className="max-w-4xl w-full shadow-lg rounded-lg p-6 space-y-6">
        <h2 className="text-3xl font-semibold text-gray-800 text-center">Admin Dashboard</h2>

        <div className="flex justify-center space-x-6 mt-8">
          <Link
            to="/admin/createmeeting"
            className="px-6 py-2 bg-blue-600 text-white rounded-xl shadow hover:bg-blue-700 transition"
          >
            Create Meeting
          </Link>
          <Link
            to="/admin/updatemeeting"
            className="px-6 py-2 bg-green-600 text-white rounded-xl shadow hover:bg-green-700 transition"
          >
            Update Meeting
          </Link>
          <Link
            to="/admin/resendpassword"
            className="px-6 py-2 bg-purple-600 text-white rounded-xl shadow hover:bg-purple-700 transition"
          >
            Resend Temp Password
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
